import { Note, TimeSignature } from "./core";

export namespace Metronome {

    export type BeatStrenght = 'weak' | 'strong';
    export type BeatPattern = BeatStrenght[];

    export function makeMetronomeBeatSequence(ts: TimeSignature): BeatPattern {
        const length = ts.numerator;
        const pattern: BeatPattern = Array(length).fill('weak');
        pattern[0] = 'strong'; // first beat is always strong

        return pattern;
    }

    export function beatStrengthToNote(bs: BeatStrenght): Note {
        switch (bs) {
            case 'strong':
                return Note.fromName('C6');
            case 'weak':
                return Note.fromName('C5');
            default:
                throw new Error(`Unknown beat strength: ${bs}`);
        }
    }

    export class ActivityObserver {
        private static instance: ActivityObserver;
        private listeners: ((step: number) => void)[] = [];
        private lastListenerId = 0;

        private constructor() {}

        static getInstance() {
            if (!ActivityObserver.instance) {
                ActivityObserver.instance = new ActivityObserver();
            }
            return ActivityObserver.instance;
        }

        updateBar(step: number) {
            this.listeners.forEach(l => l(step));
        }

        clearListeners() {
            this.listeners = [];
        }

        drop(id: number) {
            this.listeners = this.listeners.filter((_, i) => i !== id);
        }

        listen(l: (stop: number) => void): number {
            this.lastListenerId++;
            this.listeners.push(l);
            return this.lastListenerId;
        }
    }
}